import type { TPlayer } from 'video.js'

import { MessageBus } from '@setplex/mqbw'
import { setup as setupCore } from './events/videojs'

/**
 * Global singleton message bus for all players
 */
export const mq = new MessageBus('pureya')
// globalThis.__PUREYA_MQ__ = mq

/**
 * Connect new player instance to the message bus
 */
export function connectMQ(player: TPlayer) {
  setupCore(mq, player)
}
